import { render, staticRenderFns } from "./ExamResults.vue?vue&type=template&id=a19f162c&scoped=true"
import script from "./ExamResults.vue?vue&type=script&lang=js"
export * from "./ExamResults.vue?vue&type=script&lang=js"
import style0 from "./ExamResults.vue?vue&type=style&index=0&id=a19f162c&prod&scoped=true&lang=css"
import style1 from "./ExamResults.vue?vue&type=style&index=1&id=a19f162c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19f162c",
  null
  
)

export default component.exports